const pagesSettingsPermissionAndRolesEn = {
  categoryPermissions: {
    actionButtonMenu: {
      create: 'Create category permission'
    },
    dataTableCard: {
      columns: {
        grantedLargeCategoryCount: 'Large category',
        grantedMediumCategoryCount: 'Medium category',
        grantedSmallCategoryCount: 'Small category',
        name: 'Category permission name',
        referencedRoles: 'Referenced roles'
      },
      deleteConfirmDialog: {
        description: 'Deleting this category permission cannot be undone. Are you sure you want to proceed?'
      }
    },
    filterBarButtons: {
      freeText: {
        placeholder: 'Filter category permission name...'
      }
    },
    filterBarTabs: {
      actionButtonMenu: {
        create: 'Create category permission'
      },
      tabs: {
        ALL: 'All',
        all: 'All',
        archived: 'Archived',
        portal: 'Portal',
        staff: 'Staff'
      }
    }
  },
  categoryPermissionsDetail: {
    accessibleCategories: {
      description: 'You can see the accessible category nodes for this permission.',
      title: 'Accessible categories'
    },
    basic: {
      categoryPermissionName: 'Category permission name',
      description: 'Description',
      title: 'Basic'
    },
    productFilters: {
      contract: 'Contract',
      device: 'Device',
      people: 'People',
      software: 'Software'
    },
    tabs: {
      accessibleCategories: 'Accessible Categories',
      detail: 'Detail'
    }
  },
  common: {
    actions: {
      archive: 'Archive',
      delete: 'Delete',
      edit: 'Edit'
    }
  },
  createCategoryPermission: {
    addStepperCompleteDialog: {
      create: {
        completeLinkButtonText: 'Go to category permissions',
        completeMessage: 'Category permission created successfully'
      },
      update: {
        completeLinkButtonText: 'Go to category permissions',
        completeMessage: 'Category permission updated successfully'
      }
    },
    addStepperNavigation: {
      accessibleCategory: 'Accessible category',
      basic: 'Basic',
      contracts: 'Contracts',
      devices: 'Devices',
      people: 'People',
      setCategoryPermission: 'Set category permissions',
      softwares: 'Softwares',
      title: {
        create: 'Create category permission',
        update: 'Update category permission'
      }
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: 'Please enter a category permission name'
      },
      setCategoryPermission: {
        permissionRequired: 'Please select at least one category'
      }
    },
    addStepperStepTitleCard: {
      basic: '1. Basic',
      contracts: 'Contracts',
      devices: 'Devices',
      people: 'People',
      setCategoryPermission: '2. Set category permissions',
      softwares: 'Softwares'
    },
    form: {
      description: 'Description',
      descriptionPlaceholder: 'Describe the purpose of this category permission.',
      duplicateName: 'This category permission name is already in use. Please choose a different name.',
      name: 'Category permission name',
      namePlaceholder: "IT team's category permission",
      optional: '(Optional)'
    },
    setCategoryPermission: {
      description: 'Check the categories you want to grant access to.',
      title: 'Set category permissions'
    }
  },
  createPeopleGroup: {
    addStepperCompleteDialog: {
      create: {
        completeLinkButtonText: 'Go to people groups',
        completeMessage: 'People group created successfully'
      },
      update: {
        completeLinkButtonText: 'Go to people groups',
        completeMessage: 'People group updated successfully'
      }
    },
    addStepperNavigation: {
      basic: 'Basic',
      confirmPeopleGroup: 'Confirm people group',
      reviewTheImpactedRole: 'Review the impacted role',
      setMembership: 'Set membership',
      title: {
        create: 'Create people group',
        update: 'Update people group'
      }
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: 'Name is required'
      },
      setMembership: {
        membershipRequired: 'Membership is required'
      }
    },
    addStepperStepTitleCard: {
      basic: '1. Basic',
      confirmPeopleGroup: '3. Confirm people group',
      reviewTheImpactedRole: '4. Review the impacted role',
      setMembership: '2. Set membership'
    },
    confirmPeopleGroup: {
      filterBarButtons: {
        freeText: {
          placeholder: 'Filter name...'
        }
      }
    },
    form: {
      duplicateName: 'This name is already in use. Please choose a different one.',
      intendedUse: 'Intended use',
      intendedUsePlaceholder: 'Describe what this people group is for.',
      mentionKeyword: 'Mention keyword',
      name: 'Name',
      namePlaceholder: 'XXX People Group',
      optional: '(Optional)'
    }
  },
  createProductPermission: {
    addStepperCompleteDialog: {
      create: {
        completeLinkButtonText: 'Check details',
        completeMessage: 'Product permission created successfully'
      },
      update: {
        completeLinkButtonText: 'Check details',
        completeMessage: 'Product permission updated successfully'
      }
    },
    addStepperNavigation: {
      basic: 'Basic',
      reviewTheImpactedRole: 'Review the impacted role',
      setPermission: 'Set permission',
      title: {
        create: 'Create product permission',
        update: 'Update product permission'
      }
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: 'Name is required'
      },
      setPermission: {
        permissionRequired: 'Permission is required'
      }
    },
    addStepperStepTitleCard: {
      basic: '1. Basic',
      reviewTheImpactedRole: '3. Review the impacted role',
      setPermission: '2. Set permission'
    },
    form: {
      duplicateName: 'This name is already in use. Please choose a different one.',
      intendedUse: 'Intended use',
      intendedUsePlaceholder: 'Describe what this product permission is for.',
      name: 'Name',
      namePlaceholder: 'XXX Product Permission',
      optional: '(Optional)'
    },
    setPermission: {
      description: 'Select the products to enable access.',
      title: 'Set permission'
    }
  },
  createRole: {
    addStepperCompleteDialog: {
      create: {
        completeLinkButtonText: 'Go to roles',
        completeMessage: 'Role created successfully'
      },
      update: {
        completeLinkButtonText: 'Go to roles',
        completeMessage: 'Role updated successfully'
      }
    },
    addStepperNavigation: {
      basic: 'Basic',
      selectCategoryPermission: 'Select category permission',
      selectPeopleGroup: 'Select people group',
      setPermission: 'Set product permission',
      title: {
        create: 'Create role',
        update: 'Update role'
      }
    },
    addStepperPanelProgress: {
      basicForm: {
        nameRequired: 'Name is required'
      },
      selectPeopleGroup: {
        peopleGroupRequired: 'People group is required'
      },
      setPermission: {
        permissionRequired: 'Product permission is required'
      }
    },
    addStepperStepTitleCard: {
      basic: '1. Basic',
      selectCategoryPermission: '4. Select category permission',
      selectPeopleGroup: '2. Select people group',
      setPermission: '3. Set product permission'
    },
    form: {
      duplicateName: 'This name is already in use. Please choose a different one.',
      intendedUse: 'Intended use',
      intendedUsePlaceholder: 'Describe what this role is for.',
      name: 'Name',
      namePlaceholder: 'XXX Role',
      optional: '(Optional)'
    },
    selectCategoryPermission: {
      clearAll: 'Clear all',
      noResults: 'No results found',
      remove: 'Remove',
      searchPlaceholder: 'Search category permission...',
      selectedCount: 'category permission(s) selected',
      title: 'Select category permission'
    },
    selectPeopleGroup: {
      noResults: 'No results found',
      peopleIncluded: 'People included',
      searchPlaceholder: 'Search people group...',
      title: 'Select people group'
    },
    selectPermission: {
      accessibleProducts: 'Accessible products',
      noResults: 'No results found',
      searchPlaceholder: 'Search product-level access permission...',
      title: 'Select product permission'
    }
  },
  peopleGroups: {
    dataTableCard: {
      actionsColumn: {
        deprecate: 'Deprecate'
      },
      peopleGroupMembershipColumn: {
        rule: {
          workerType: {
            // TODO: common.workerType に統一したい
            BOARD_MEMBER: 'Board Member',
            COLLABORATOR: 'Collaborator',
            CONTRACTOR: 'Contractor',
            EMPLOYEE: 'Employee'
          }
        }
      }
    },
    filterBarButtons: {
      freeText: {
        placeholder: 'Filter name...'
      }
    },
    filterBarTabs: {
      actionButtonMenu: {
        create: 'Create people group'
      },
      tabs: {
        ALL: 'All'
        // UNNAMED: "Unnamed",
        // DEPRECATED: "Deprecated",
      }
    },
    title: 'People Groups'
  },
  peopleGroupsDetail: {
    basic: {
      groupName: 'Name',
      intendedUse: 'Intended Use',
      mentionKeyword: 'Mention Keyword',
      title: 'Basic'
    },
    peopleGroupInTheGroupCard: {
      searchInput: {
        placeholder: 'Filter name...'
      },
      title: 'People group in the group'
    },
    workerTypeRuleCard: {
      description: 'Set the conditions for defining people to be included in the People Group.',
      title: 'Membership'
    }
  },
  productPermissions: {
    dataTableCard: {
      actionsColumn: {
        deprecate: 'Deprecate'
      }
    },
    filterBarButtons: {
      freeText: {
        placeholder: 'Filter name...'
      }
    },
    filterBarTabs: {
      actionButtonMenu: {
        create: 'Create product permission'
      },
      tabs: {
        ALL: 'All'
        // DEPRECATED: "Deprecated",
      }
    }
  },
  productPermissionsDetail: {
    accessibleProducts: {
      description: 'You can see a list of accessible products.',
      title: 'Accessible products'
    },
    basic: {
      intendedUse: 'Intended Use',
      productPermissionName: 'Name',
      title: 'Basic'
    },
    roleUsing: {
      description: 'You can see a list of roles using this permission.',
      searchInput: {
        placeholder: 'Filter name...'
      },
      title: 'Role using'
    }
  },
  roles: {
    filterBarButtons: {
      freeText: {
        placeholder: 'Filter name...'
      }
    },
    filterBarTabs: {
      actionButtonMenu: {
        create: 'Create role'
      },
      tabs: {
        ALL: 'All'
        // DEPRECATED: "Deprecated",
      }
    }
  },
  rolesDetail: {
    basic: {
      intendedUse: 'Intended Use',
      roleName: 'Name',
      title: 'Basic'
    },
    categoryPermissionDataTableCard: {
      description: 'Category permissions define access control at the category and field level. By linking to a role, permissions can be managed dynamically.',
      permissionName: 'Category permission name',
      title: 'Category permission'
    },
    peopleGroupDataTableCard: {
      description: 'A People Group defines a group of individuals based on specific conditions. By linking it to a Role, permissions can be managed dynamically.',
      title: 'People group'
    },
    productPermissionDataTableCard: {
      description: 'Product permissions define access permit to the products of Dress Code. Depending on the granted permissions, the menu items in the sidebar may change dynamically.',
      title: 'Product permission'
    }
  },
  title: 'Permission & Roles'
};
export default pagesSettingsPermissionAndRolesEn;